import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    cardState: String,
    hasBrands: Boolean,
    numContentItems: Number,
  };

  connect() {
    this.trackCardShown();
  }

  trackCardShown() {
    if (typeof window.posthog !== "undefined") {
      window.posthog.capture("influencer_insights_card_shown", {
        card_state: this.cardStateValue,
        has_brands: this.hasBrandsValue,
        num_content_items: this.numContentItemsValue,
      });
    }
  }

  trackCtaClick() {
    if (typeof window.posthog !== "undefined") {
      window.posthog.capture("influencer_insights_card_cta_clicked", {
        card_state: this.cardStateValue,
        cta_type:
          this.cardStateValue === "empty"
            ? "connect_accounts"
            : "report_builder",
      });
    }
  }
}
